import { ShiftReport } from "@/pages/shift-report";

export const routeShiftReport = "/mill/shift-report";
export const shiftReportPermission = "ui.navbar.shift.report";

export const shiftReportRoutes = [
	{
		path: `${routeShiftReport}`,
		element: <ShiftReport />,
		permission: shiftReportPermission,
	},
	{
		path: `${routeShiftReport}/:shiftId`,
		element: <ShiftReport />,
		permission: shiftReportPermission,
	},
];
